




































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Feedback, roleType } from '@/Feedback'
import { TokenUser } from '@/TokenUser'
import { Account, SetCS } from '@/Account'
import * as utils from '@/utils';
import * as utils_time from '@/utils_time';
import * as utils_topshot from '@/utils_topshot';
import ModalWrapperComponent from '@/components/ModalWrapperComponent.vue';           // @ is an alias to /src
import AccountUsernameComponent from '@/components/AccountUsernameComponent.vue';                       // @ is an alias to /src
import { AccountExtra, AccountForLeaderboard } from '@/AccountExtra';

@Component({
  name: 'LeaderboardSetList',
  components: { ModalWrapperComponent, AccountUsernameComponent }
})
export default class LeaderboardSetListComponent extends Vue {
  // prop reactive member variables publically available to the html template
  @Prop({ default: null })
  public account: AccountForLeaderboard

  @Prop({ default: 0 })
  public index: number                 // in case it's ever useful for us to know where we are in the main list

  @Prop()
  public setID: number

  @Prop()
  public setName: string


  // public reactive member variables available to the html template

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }
  public get user(): TokenUser { return this.$store.getters.userObject }
  public get userId(): string { return this.$store.getters.userId }

  public clickedName(flowAddress: string) {
    const url: string = Account.getPortfolioLink(flowAddress)
    if (url) window.open(url, "_blank"); 
  }

  public get cs(): number {
    for (const setCS of this.account.accountExtra.setCS2bs) if (setCS.setID === this.setID) return Number(setCS.score)
    return 0
  }

  public get percent(): string {
    if (!this.account.account.collectorScore2b) return '---'
    return `${(this.cs  * 100 / this.account.account.collectorScore2b.total).toPrecision(3)}%`
  }

  public get moments(): number {
    for (const setCS of this.account.accountExtra.setCS2bs) if (setCS.setID === this.setID) return Number(setCS.moments)
    return 0
  }

  public get percentMoments(): string {
    if (!this.account.account.collectorScore2b) return '---'
    return `${(this.moments  * 100 / this.account.account.collectorScore2b.numMoments).toPrecision(3)}%`
  }

  // private, non-reactive member variables

  // private functions not available directly to HTML template
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted() with index = ${this.index}`)
  }

  private async beforeDestroy() { 
    if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy() with index = ${this.index}`)
  }

}
